import React, { useEffect, useState } from 'react'
import { getSiteMemory } from "../services/stateAPI";
import AppMenu from '../components/AppMenu';
import { title } from "../config";
import { Table } from 'reactstrap';
import { BackButton } from '../components/BackButton';
import { useToast } from "../components/ToastContext";
import '../assets/css/Memory.css'


const Memory = ({ }) => {
    const { showToast } = useToast();
    const [pageTitle, setPageTitle] = useState("Memory");
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const dayBeforeYesterday = new Date(today);
    dayBeforeYesterday.setDate(today.getDate() - 2);

    const getPerSapce = (free, size) => {
        if (free === undefined || free === null || size === undefined || size === null || isNaN(free) || isNaN(size) || Number(size) === 0) {
            return null;
        }
        const percentageFull = ((Number(size) - Number(free)) / Number(size)) * 100;
        return percentageFull.toFixed(2);
    };
    const reloadSiteMemory = async () => {
        let data = await getSiteMemory(showToast);

        if (!Array.isArray(data)) {
            if (typeof data === "string") {
                try {
                    data = JSON.parse(data);
                } catch (err) {
                    console.error("Failed to parse data:", err);
                    data = [];
                }
            } else {
                data = [];
            }
        }

        setLoading(false);
        const modifyResult = data.map((e) => {
            const memData = e.memoryData || {};
            const fullMemoryPrDay1 = getPerSapce(memData.Day1, e.size);
            const fullMemoryPrDay2 = getPerSapce(memData.Day2, e.size);
            const fullMemoryPrDay3 = getPerSapce(memData.Day3, e.size);

            const memoryDiffDay1Day2 = (memData.Day2 !== undefined && memData.Day1 !== undefined) ? (memData.Day2 - memData.Day1) : null;
            const memoryDiffDay2Day3 = (memData.Day3 !== undefined && memData.Day2 !== undefined) ? (memData.Day3 - memData.Day2) : null;

            const modifiedMemoryData = {
                fullMemoryPrDay1: fullMemoryPrDay1, Day1Memory: memData.Day1,
                fullMemoryPrDay2: fullMemoryPrDay2, Day2Memory: memData.Day2,
                fullMemoryPrDay3: fullMemoryPrDay3, Day3Memory: memData.Day3,
            };
            return {
                ...e,
                memoryData: modifiedMemoryData,
                memoryDiffDay1Day2,
                memoryDiffDay2Day3
            };
        });
        const sortedResult = modifyResult.sort((a, b) => (b.memoryDiffDay1Day2 || 0) - (a.memoryDiffDay1Day2 || 0));
        setItems(sortedResult);
    };
    const getGBData = (totalSize) => {
        return (totalSize / 1073741824).toFixed(2);
    };
    const getMBData = (totalSize) => {
        return (totalSize / 1048576).toFixed(2);
    };
    const formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    useEffect(() => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new window.bootstrap.Tooltip(tooltipTriggerEl);
        });
        reloadSiteMemory();
    }, []);

    return (
        <div className="memory-table-container">   <div>
            <div className="px-2 sticky-header">
                <h3 className="m-0 p-2">{title} | {pageTitle}</h3>
                <AppMenu />
            </div>
            <div className="p-0 px-2 m-0">
                <div className="px-2 sticky-header">
                    <BackButton icon="←" />
                    <b>Total:{items.length} &nbsp;&nbsp;</b>
                </div>
                <hr className="p-0 my-2" />
            </div>
            <div className="p-0 m-0 px-2">
                <Table className="table table-hover" responsive hover>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Disk Storage (Total)</th>
                            <th>RAM Usage</th>
                            <th>{`${formatDate(today)}`}</th>
                            <th>{`${formatDate(yesterday)}`}</th>
                            <th>{`${formatDate(dayBeforeYesterday)}`}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => {
                            const ramUsedPercent = item.ramUsagePercent !== undefined
                                ? item.ramUsagePercent
                                : (item.totalMem && item.freeMem !== undefined && item.totalMem > 0)
                                    ? Math.round(((item.totalMem - item.freeMem) / item.totalMem) * 100)
                                    : null;
                            const isHighRam = ramUsedPercent !== null && ramUsedPercent >= 80;

                            return (
                                <tr key={item._id}>
                                    <td style={{ width: "250px" }}>{item.name}</td>
                                    <td>{item.size ? `${getGBData(item.size)} GB` : '-'}</td>
                                    <td>
                                        {item.totalMem ? (
                                            <div>
                                                <span>{item.freeMem !== undefined ? `${item.freeMem} MB Free` : ''} / {item.totalMem} MB</span>
                                                {ramUsedPercent !== null && (
                                                    <span className={`badge ms-2 ${isHighRam ? 'bg-danger text-white' : 'bg-success text-white'}`} style={{ fontSize: '0.75rem' }}>
                                                        {ramUsedPercent}% used
                                                    </span>
                                                )}
                                            </div>
                                        ) : '-'}
                                    </td>
                                    <td>
                                        {item.memoryData && item.memoryData.fullMemoryPrDay1 ? (
                                            <div className="memory-info">
                                                <span>
                                                    {item.memoryData.fullMemoryPrDay1}% Full
                                                    <br />
                                                    Avail: {getGBData(item.memoryData.Day1Memory)} GB
                                                    {item.memoryDiffDay1Day2 !== null && item.memoryDiffDay1Day2 !== undefined && (
                                                        <>
                                                            <br />Mem Diff:
                                                            {item.memoryDiffDay1Day2 > 0
                                                                ? <div style={{ color: "red" }}>{getMBData(item.memoryDiffDay1Day2)}MB</div>
                                                                : `(${getMBData(item.memoryDiffDay1Day2)}MB)`}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        ) : '-'}
                                    </td>
                                    <td>
                                        {item.memoryData && item.memoryData.fullMemoryPrDay2 ? (
                                            <div className="memory-info">
                                                <span>
                                                    {item.memoryData.fullMemoryPrDay2}% Full
                                                    <br />
                                                    Avail: {getGBData(item.memoryData.Day2Memory)} GB
                                                    {item.memoryDiffDay2Day3 !== null && item.memoryDiffDay2Day3 !== undefined && (
                                                        <>
                                                            <br />Mem Diff:
                                                            {item.memoryDiffDay2Day3 > 0
                                                                ? <div style={{ color: "red" }}>{getMBData(item.memoryDiffDay2Day3)}MB</div>
                                                                : <div style={{ color: "green" }}>({getMBData(item.memoryDiffDay2Day3)}MB)</div>}
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        ) : '-'}
                                    </td>
                                    <td>
                                        {item.memoryData && item.memoryData.fullMemoryPrDay3 ? (
                                            <div className="memory-info">
                                                <span>
                                                    {item.memoryData.fullMemoryPrDay3}% Full
                                                    <br />
                                                    Avail: {getGBData(item.memoryData.Day3Memory)} GB
                                                </span>
                                            </div>
                                        ) : '-'}
                                    </td>
                                </tr>
                            );
                        })}

                    </tbody>
                </Table>
            </div>
            {loading ? (
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Loading data...</p>
                </div>
            ) : items.length === 0 ? (
                <div className="text-center p-5">
                    <div className="mb-3">
                        <i className="fas fa-database fa-3x text-muted"></i>
                    </div>
                    <h5 className="text-muted mb-2">No Data Available</h5>
                    <p className="text-muted">There are no records to display at the moment.</p>
                </div>
            ) : null}
        </div></div>
    )
}

export default Memory